// ABOUTME: Confirmation dialog for removing a calendar connection from the family.
// ABOUTME: Warns that all child calendar selections for this connection will be removed.

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@mui/material';
import { CalendarConnectionDto } from '../../../types/api';

interface RemoveCalendarConnectionDialogProps {
  open: boolean;
  connection: CalendarConnectionDto | null;
  removing: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const RemoveCalendarConnectionDialog: React.FC<RemoveCalendarConnectionDialogProps> = ({
  open,
  connection,
  removing,
  onClose,
  onConfirm
}) => {
  if (!connection) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="remove-calendar-connection-dialog"
    >
      <DialogTitle>Remove Calendar Source</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove <strong>{connection.displayName}</strong>?
        </Typography>
        <Typography sx={{ mt: 2, color: 'text.secondary' }}>
          This will remove the calendar source and unselect its calendars from all children.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={removing}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={removing}
        >
          {removing ? <CircularProgress size={24} /> : 'Remove'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveCalendarConnectionDialog;
